import type { ThreadDetailPost } from "./types";

/**
 * Post の全添付ファイルから SHA256 ハッシュを抽出する。
 * NG 画像突合 (`useNgStore.isPostHidden`) で利用する。
 */
export function getAttachmentHashes(
  post: Pick<ThreadDetailPost, "attachments">,
): string[] {
  return post.attachments.map((a) => a.sha256Hash);
}
